function FullPageLoader() {
  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{ backgroundColor: "rgba(255, 255, 255, 0.8)", zIndex: 9999 }}
    >
      <img src="/loader.gif" width="150" alt="Loading..." />
    </div>
  );
}

export default FullPageLoader;
